import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import {
    Alert,
    Form,
    FormGroup,
    Label,
    Container,
    Col,
    Row,
    Button,
    Input,
} from 'reactstrap'
import axios from 'axios'

export default function Unsubscribe() {
    const [submitted, setSubmitted] = useState(false)
    const [submitError, setSubmitError] = useState(false)
    const [email, setEmail] = useState('')
    const [resMsg, setResMsg] = useState('')

    const handleSubmit = (event) => {
        event.preventDefault()
        window.scrollTo(0, 0)
        setSubmitted(true)
        axios(global.host + 'news/unsubscribe.php', {
            method: 'POST',
            data: {
                email: email,
            },
        })
            .then((response) => {
                setResMsg(response.data.message)
                setSubmitError(response.data.error)
            })
            .catch((error) => {
                setResMsg('Något gick fel, försök igen senare.')
                setSubmitError(true)
            })
    }

    return (
        <Container fluid className="fluid footer-email">
            <Helmet>
                <meta charSet="utf-8" />
                <title>Avsluta prenumeration | Brf Lyfta</title>
                <meta
                    name="description"
                    content="Avsluta prenumerationen och sluta ta emot nyhetsbrev från styrelsen."
                />
            </Helmet>

            <Row>
                <Col
                    sm="12"
                    md={{
                        size: 6,
                        offset: 3,
                    }}
                >
                    <h3 className="text-center">Avsluta Prenumeration</h3>
                    <p className="text-center">
                        Fyll i din e-postadress nedan för att avsluta din
                        prenumeration på nyhetsflödet. Du kommer inte längre att
                        ta emot några utskick.
                    </p>
                </Col>
            </Row>

            {submitted ? (
                <Alert
                    color={submitError ? 'danger' : 'success'}
                    isOpen={submitted}
                >
                    {resMsg}
                </Alert>
            ) : (
                <Form onSubmit={handleSubmit}>
                    <FormGroup>
                        <Label for="email">E-postadress</Label>
                        <Input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            name="email"
                            id="email"
                            placeholder="epost@hotmail.com"
                        />
                    </FormGroup>
                    <Button type="submit" color="danger">
                        Avsluta prenumeration
                    </Button>
                </Form>
            )}
        </Container>
    )
}
